import React from "react";

export const ActionButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    focused?: boolean;
  }
>(function ActionButton(
  { children, className, focused, type = "button", ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={`border border-[#e6e6e6] ${focused ? "bg-[#f2efff]" : "bg-white"}
      shadow-[0_1px_2px_rgba(16,24,40,0.05)] rounded-[8px] text-[#333] size-[24px] p-0
      hover:bg-[#f9f9f9] hover:border-[#e6e6e6] disabled:bg-white disabled:border-neutral-100 disabled:text-neutral-200
      flex items-center justify-center enabled:cursor-pointer disabled:cursor-not-allowed
      [&_i]:inline-flex [&_i]:size-[15px] [&_i]:items-center [&_i]:justify-center [&_i]:leading-none
      ${className || ""}`}
      {...props}
    >
      {children}
    </button>
  );
});
